export enum MountPlacement {
  PAGE = 'page',
  PARENT = 'parent',
  BODY = 'body'
}

export enum ComponentPlacement {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TOP_LEFT = 'topLeft',
  TOP_RIGHT = 'topRight',
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM_RIGHT = 'bottomRight',
  LEFT_TOP = 'leftTop',
  LEFT_BOTTOM = 'leftBottom',
  RIGHT_TOP = 'rightTop',
  RIGHT_BOTTOM = 'rightBottom'
}
